/**
 * VERSIONE LIBRERIA 3
 */
var RenderTime = Render.extend({
    type : 'time',
    classData : 'time',
    classTemplate : 'time',
    hour_selector : "[data-render_hour]",
    minute_selector : "[data-render_minute]",
    second_selector : "[data-render_second]",

    _renderEdit : function(jQe) {
        var self = this;
        self._setData(jQe,self.key)
    },
    _renderSearch : function(jQe) {
        var self = this;
        self._setData(jQe,'s_' + self.key + '[]');
        $('<input>').attr({
            type: 'hidden',
            name: 's_' + self.key + "_operator",
            'data-control_operator' : self.key,
            value : self.operator
        }).appendTo(jQe);
    },
    _setData : function (jQe,inputName) {
        var self = this;
        var el = jQe.find(self.element_selector);
        el.find(self.control_selector).attr("name", inputName);
        el.find(self.control_selector).attr("value", self.value);
        var elH = el.find('[data-render_hour]');
        for (var i=0;i<24;i++) {
            var v = i>=10?i:'0'+i;
            var opt = $('<option>').attr({
                value : v
            });
            opt.html(v);
            elH.append(opt);
        }
        var elM = el.find(self.minute_selector);
        var elS = el.find(self.second_selector);
        for (var i=0;i<60;i++) {
            var v = i>=10?i:'0'+i;
            var optm = $('<option>').attr({
                value : v
            });
            var opts = $('<option>').attr({
                value : v
            });
            optm.html(v);
            opts.html(v);
            elM.append(optm);
            elS.append(opts);
        }
        //el.find(self.hour_selector).attr('data-render_hour', self.key);
        //el.find(self.minute_selector).attr('data-render_minute', self.key);
        //el.find(self.second_selector).attr('data-render_second', self.key);
    },
    _finalizeEdit : function () {
        var self = this;
        $(self.container).find(self.hour_selector+","+ self.minute_selector + "," + self.second_selector).change(function () {
            var stime = $(self.container).find(self.hour_selector).val() + ":"
                        + $(self.container).find(self.minute_selector).val() + ":"
                        + $(self.container).find(self.second_selector).val();
            $(self.container).find(self.control_selector).val(stime);
        });
        try {
            var t = $(self.container).find(self.control_selector).val().split(":");
            $('[data-render_hour="' + self.key + '"]').val(t[0]);
            $('[data-render_minute="' + self.key + '"]').val(t[1]);
            $('[data-render_second="' + self.key + '"]').val(t[2]);
        } catch (e) {
            log.error(e);
        }

        /*
        $(self.container).find('[data-render_hour="' + self.key + '"],[data-render_minute="' + self.key + '"],[data-render_second="' + self.key + '"]').change(function () {
            var stime = $('[data-render_hour="' + self.key + '"]').val() + ":" + $('[data-render_minute="' + self.key + '"]').val() + ":" + $('[data-render_second="' + self.key + '"]').val();
            $(self.container).find(self.control_selector).val(stime)
        });
        try {
            var t = $(self.container).find(self.control_selector).val().split(":");
            $('[data-render_hour="' + self.key + '"]').val(t[0]);
            $('[data-render_minute="' + self.key + '"]').val(t[1]);
            $('[data-render_second="' + self.key + '"]').val(t[2]);
        } catch (e) {
            log.error(e);
        }
        */
    },
    _finalizeSearch : function (){},

    getValue : function () {
        return $(this.container).find(this.control_selector).val();
    }
});